// Unpublished Work © 2022-2024 Deere & Company.

import SwitchInput from 'Ui/components/common/form/switch-input';
import React from 'react';
import {IconAdd, IconTerminal} from '@deere/icons';
import OnlinkButton from 'Ui/components/common/onlink-button';

const ICON_STYLE = {
    style: {
        height: '15px',
        width: '15px'
    }
};

function getFilterComponent(
    showArchived,
    setShowArchived,
    translations
) {
    return (
        <div className='extra-table-options'>
            <SwitchInput
                checked={showArchived}
                name='showArchived'
                onChange={() => setShowArchived(!showArchived)}
                onLabel={translations.ONLINK_SHOW_ARCHIVED}
                translations={translations}
            />
        </div>
    );
}

function getAdditionalTableOptionRow(translations, onAddEquipmentClick, isMobile) {
    if (!isMobile) {
        return (
            <OnlinkButton
                className='primary add-equipment-button'
                onClick={onAddEquipmentClick}
                startIcon={<IconAdd/>}
                variant='primary'
            >
                {translations.equipment_add_equipment}
            </OnlinkButton>
        );
    }

    return null;
}

function getFleetLegend(translations) {
    return (
        <div className='onequip-legend'>
            <IconTerminal {...ICON_STYLE}/>
            <div className='telematics-enabled-text'>
                {translations.ONLINK_TELEMATICALLY_ENABLED}
            </div>
        </div>
    );
}

export {
    getFilterComponent,
    getAdditionalTableOptionRow,
    getFleetLegend
};
